import { PropTypes } from '@elliemae/ds-props-helpers';
import type { GlobalAttributesT, XstyledProps, ValidationMap } from '@elliemae/ds-props-helpers';
import type { DSButtonT } from '../SharedButtonBaseline/react-desc-prop-types.js';
import { DSButtonPropTypes } from '../SharedButtonBaseline/react-desc-prop-types.js';
import { DSButtonV2DataTestId } from './DSButtonV2Definitions.js';

export namespace DSButtonV2T {
  export interface DefaultProps extends DSButtonT.DefaultProps {}

  export interface OptionalProps extends DSButtonT.OptionalProps {}

  export interface RequiredProps extends Omit<DSButtonT.RequiredProps, 'isV3'> {}

  export interface Props
    extends
      Partial<DefaultProps>,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLButtonElement>, keyof DefaultProps | keyof OptionalProps | keyof RequiredProps>,
      XstyledProps,
      RequiredProps {}

  export interface InternalProps
    extends
      DefaultProps,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLButtonElement>, keyof DefaultProps | keyof OptionalProps | keyof RequiredProps>,
      XstyledProps,
      RequiredProps {}
}

export const DSButtonV2PropTypes = {
  ...DSButtonPropTypes,
  'data-testid': PropTypes.string.description('Root element data-testid.').defaultValue(DSButtonV2DataTestId.ROOT),
} as ValidationMap<unknown>;
